import { __extends } from "tslib";
import * as _ from 'lodash';
import { RenderUtils } from '@wix/photography-client-lib';
import { isDeviceTypeMobile, isSiteMode } from './viewModeWrapper.js';
var Utils = /** @class */ (function (_super) {
    __extends(Utils, _super);
    /* @ngInject */
    function Utils() {
        var _this = _super.call(this) || this;
        _this._cache = {};
        _this._hash2int = {};
        _this._refs = {};
        _this._params = {};
        _this.CONST_ADI_SUPPORT_WIDGET_CODE = '63ff21be-9556-4f52-9ac9-4d441bd3dae4';
        _this.CONST_EDITOR_WIDGET_CODE = 'cb6480f3-768b-4737-ab8f-10fe2e4fa2ab';
        try {
            document.domain = 'wixapps.net';
        }
        catch (e) {
            // console.warn('failed to set domain');
        }
        _this.isAccessibilityEnabled(); // populate the cache with the sdk response
        return _this;
    }
    Utils.prototype.setStateAndLog = function (that, caller, state, callback) {
        var _this = this;
        if (this.isVerbose()) {
            console.log("State Change Called (".concat(caller, ")"), state);
            var oldState_1 = _.clone(that.state);
            that.setState(state, function () {
                var newState = _.clone(that.state);
                var change = _this.printableObjectsDiff(oldState_1, newState, 'state');
                if (_.keys(change).length > 0) {
                    console.log("State Change Completed (".concat(caller, ")"), change);
                }
                if (_.isFunction(callback)) {
                    callback.bind(that)();
                }
            });
        }
        else {
            that.setState(state, function () {
                if (_.isFunction(callback)) {
                    callback.bind(that)();
                }
            });
        }
    };
    Utils.prototype.printableObjectsDiff = function (obj1, obj2, prefix) {
        if (prefix === void 0) { prefix = ''; }
        var toString = function (v) {
            if (v === '') {
                v = "''";
            }
            else if (_.isUndefined(v)) {
                v = 'undefined';
            }
            return _.toString(v);
        };
        var getInnerDiff = function (obj1, obj2, prefix) {
            var innerDiff = _.reduce(obj1, function (res, v, k) {
                if (!_.isEqual(v, obj2[k])) {
                    if (_.isArray(obj2[k])) {
                        if (v.length !== obj2[k].length) {
                            res[k + '.length'] =
                                '[' + v.length + '] => [' + obj2[k].length + ']';
                        }
                        res = _.merge(res, getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
                    }
                    else if (_.isObject(obj2[k])) {
                        res = _.merge(res, getInnerDiff(v, obj2[k], (prefix ? prefix + '.' : '') + k));
                    }
                    else {
                        res[(prefix ? prefix + '.' : '') + k] =
                            toString(v) + ' => ' + toString(obj2[k]);
                    }
                }
                return res;
            }, {});
            return innerDiff;
        };
        return getInnerDiff(obj1, obj2, prefix);
    };
    Utils.prototype.getViewportScaleRatio = function () {
        // 320 is a hack for wix - they have fixed viewport of 320 pixels regardlessof phone type
        if (this.isInWix() &&
            this.isMobile() &&
            !this.isMobileViewer() &&
            this.isSite()) {
            return 320 / this.getScreenWidth();
        }
        else {
            return 1;
        }
    };
    Utils.prototype.getMobileEnabledClick = function (action) {
        // todo: bring back this line before pushing to master
        return this.isMobile() ? { onTouchEnd: action } : { onClick: action };
        // return {onClick: action};
    };
    Utils.prototype.colorStringToObject = function (colorString) {
        // https://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
        try {
            var returnValue = null;
            if (typeof colorString === 'string') {
                if (colorString.trim().indexOf('rgb') === 0) {
                    // rgb(1,2,3) | rgba(4,5,6,0.7)
                    var values = colorString.match(/\d+/g);
                    if (values && Array.isArray(values) && values.length >= 3) {
                        returnValue = {
                            r: values[0],
                            g: values[1],
                            b: values[2],
                        };
                    }
                }
                else {
                    // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
                    var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
                    colorString = colorString.replace(shorthandRegex, function (m, r, g, b) {
                        return r + r + g + g + b + b;
                    });
                    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorString);
                    returnValue = result
                        ? {
                            r: parseInt(result[1], 16),
                            g: parseInt(result[2], 16),
                            b: parseInt(result[3], 16),
                        }
                        : null;
                }
            }
            return returnValue;
        }
        catch (error) {
            console.error('Error converting color string to object', error);
        }
    };
    Utils.prototype.isMobile = function () {
        var _this = this;
        var _isMobile = function () {
            var isMobile = _this.isWixMobile() || isDeviceTypeMobile();
            var isUserAgentMobile = _this.isUserAgentMobile();
            return _this.isUndefined(isMobile) ? isUserAgentMobile : isMobile;
        };
        if (this.isTest()) {
            return false;
        }
        else if (!isSiteMode()) {
            return _isMobile();
        }
        else {
            return this.getOrPutFromCache('isMobile', _isMobile);
        }
    };
    // isTouch has to be implemented here and not be extended from BaeUtils as 'isMobile' is different here from the BaseUtils
    Utils.prototype.isTouch = function () {
        var _this = this;
        return this.getOrPutFromCache('isTouch', function () {
            try {
                return (_this.isMobile() || 'ontouchstart' in window.document.documentElement);
            }
            catch (e) {
                return false;
            }
        });
    };
    Utils.prototype.hexToRgba = function (col, opa) {
        try {
            var hex = col.substring(1);
            var bigint = parseInt(hex, 16);
            var r = (bigint >> 16) & 255;
            var g = (bigint >> 8) & 255;
            var b = bigint & 255;
            return "rgba(".concat(r, ",").concat(g, ",").concat(b, ",").concat(opa, ")");
        }
        catch (e) {
            return '';
        }
    };
    return Utils;
}(RenderUtils));
export var utils = new Utils();
//# sourceMappingURL=utils.js.map